import React from "react";
import './AuthorsSection.css';
import zdjJan from "../../Images/Janek Kulka.png"
import zdjIgnacy from "../../Images/Ignacy Kulka.png"


export default function AuthorsSection(){
	return(

		<div className="authors-container">
			<div className='photos'>
				<img
					className='ignacy photo'
					alt='Ignacy Mermer'
					src={zdjIgnacy}
				/>
				<div className='surnames'>
					<p className='name'>Ignacy Mermer</p>
				</div>
			</div>

			<div className='photos'>
				<img
					className='janek photo'
					alt='Jan Burdzicki'
					src={zdjJan}
				/>
				<div className='surnames'>
					<p className='name'>Jan Burdzicki</p>
				</div>
			</div>



			<p className='opis'>
				Jesteśmy uczniami klasy drugiej IX LO im. Cypriana Kamila Norwida w Częstochowie o profilu matematyczno-
				fizyczno-informatycznym. Interesujemy się szeroko pojętym programowaniem, począwszy od programowania stron
				internetowych i aplikacji, po startowanie w konkursach algorytmicznych i Olimpiadach. Nasza przygoda z
				progrmowaniem zaczęła się w pierwszej klasie liceum, a już udało nam się wiele dokonać. Oprócz tego bardzo
				lubimy matematykę i fizykę. Codziennie staramy się poszerzać swoją wiedzę. Ostatnio zainteresowaliśmy się
				falami dźwiękowymi i ich wykorzystaniem. Ważnym elementem zaprojektowanej przez nas strony jest
				wizualizacja zjawisk fizycznych, która pozwala na dobre zaprezentowanie wybranych treści. Czerpiemy
				dużo radości z efektów końcowych 😉.
			</p>

			<br/><br/><br/>

			<p style={{textDecoration: "bold", fontSize: "45px", textAlign: "center", color:"#fff"}}>O STRONIE</p>

			<br/>

			<p className='opis'>
				Praca została przygotowana na potrzeby tegorocznej edycji konkursu „Młody Einstein”. Głównym celem
				tego projektu jest przybliżenie zagadnień związanych z dźwiękiem i jego zastosowania.
			</p>
	</div>
	);
}